import React from "react"; 
import './MainVideo.css';
import video from '../../../images/mainvid.mp4'

export function MainVideo(props) { 
   
  return (
    <section className="main-video">
    <video frameBorder="0" 
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
      allowFullScreen
      src={video} type="video/mp4"
      allowtransparency='true' className='main-video__iframe' controls >
  
    </video>
  </section>
  )
  }
   